import { useEffect } from 'react';

const useHotjarDisable = (): void => {
  const css = "div[id*='_hj_feedback_container'] {display: none;}";

  useEffect(() => {
    document.head.insertAdjacentHTML(
      'beforeend',
      `<style id="hotjarDisable">${css}</style>`
    );

    return () => {
      document.getElementById('hotjarDisable')?.remove();
    };
  }, []);
};

export { useHotjarDisable };
